import LightNode from './LightNode'
import LightButton from './LightButton'

const TYPE = 'Light'
const TRIGGER_KEY = 'l'

const hasLight = state => state.marks.count() && state.marks.some(mark => mark.type === TYPE)

const LightSchema = {
  marks: {
    Light: LightNode
  }
}

const onKeyDown = (event, data, state) => {
  if (data.isMod && data.key === TRIGGER_KEY) return onApply(state)
}

const onClickButton = (e, state) => {
  e.preventDefault()
  return onApply(state)
}

const onApply = state => {
  return state
    .transform()
    .toggleMark(TYPE)
    .focus()
    .apply()
}

const LightPlugin = options => {
  return {
    schema: LightSchema,

    onKeyDown (...args) {
      return onKeyDown(...args)
    }
  }
}

export {
  TYPE,
  TRIGGER_KEY,
  hasLight,
  onClickButton,
  LightPlugin,
  LightSchema,
  LightNode,
  LightButton
}



// WEBPACK FOOTER //
// ./src/components/LightSlatePlugin/LightSlatePluginContainer.js